"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChangeEventAttribution = exports.JOURNAL_TAG_KEYS = exports.journalTagKeyEnum = exports.JournalTagKey = exports.SKIN_AI_METRIC_GROUPS = exports.SkinAIMetricGroup = exports.fitzpatrickEnum = exports.FitzpatrickType = exports.itaClassEnum = exports.ITAClassification = exports.skinTypeZoneEnum = exports.skinTypeEnum = exports.SkinTypeClassification = exports.sensitivityLevelEnum = exports.SensitivityClassification = exports.acneSeverityEnum = exports.AcneSeverityLevel = exports.TreatmentSlug = exports.TreatmentCategory = exports.TreatmentAreaName = exports.SkinMetricAreaName = exports.SkinMetricGroupTechNameMap = exports.SkinMetricTechName = exports.SkinMetricGroup = void 0;
exports.SkinMetricGroup = {
    skin_sensitivity: 'skin_sensitivity',
    clarity_breakouts: 'clarity_breakouts',
    tone_evenness: 'tone_evenness',
    structure_aging: 'structure_aging',
    eye_area: 'eye_area',
    baseline_properties: 'baseline_properties',
};
exports.SkinMetricTechName = {
    // GROUP 1: Skin Sensitivity
    hydration: 'hydration',
    texture_roughness: 'texture_roughness',
    redness: 'redness',
    surface_sebum: 'surface_sebum',
    telangiectasia: 'telangiectasia',
    // GROUP 2: Clarity & Breakouts
    breakouts: 'breakouts',
    pores: 'pores',
    pie: 'pie',
    // GROUP 3: Tone Evenness
    pigmentation: 'pigmentation',
    sun_spots: 'sun_spots',
    melasma: 'melasma',
    freckles: 'freckles',
    // GROUP 4: Structure & Aging
    lines: 'lines',
    fine_lines: 'fine_lines',
    deep_lines: 'deep_lines',
    nasolabial_wrinkles: 'nasolabial_wrinkles',
    marionette_lines: 'marionette_lines',
    sagging: 'sagging',
    jowls: 'jowls',
    age: 'age',
    // GROUP 5: Eye Area
    dark_circles: 'dark_circles',
    puffiness: 'puffiness',
    eye_bags: 'eye_bags',
    lacrimal_grooves: 'lacrimal_grooves',
    eyes_age: 'eyes_age',
    // GROUP 6: Baseline Properties
    skin_type: 'skin_type',
    ita: 'ita',
    skintone: 'skintone',
    /**
     * @deprecated - Composite metric calculated from: hydration, texture_roughness, redness, telangiectasia
     */
    sensitivity_composite: 'sensitivity_composite',
    /**
     * @deprecated - use 'pores' instead
     */
    enlarged_pores: 'enlarged_pores',
    /**
     * @deprecated - use 'redness' instead
     */
    inflammation: 'inflammation',
    /**
     * @deprecated - use 'redness' instead
     */
    irritation: 'irritation',
    /**
     * @deprecated - use 'breakouts' instead
     */
    pimples: 'pimples',
    /**
     * @deprecated - removed (no replacement)
     */
    uniformness: 'uniformness',
    /**
     * @deprecated - removed (no replacement)
     */
    translucency: 'translucency',
    /**
     * @deprecated - removed (no replacement)
     */
    moles: 'moles',
    /**
     * @deprecated - removed (no replacement)
     */
    pigmentation_composite: 'pigmentation_composite',
};
exports.SkinMetricGroupTechNameMap = {
    [exports.SkinMetricGroup.skin_sensitivity]: [
        exports.SkinMetricTechName.hydration,
        exports.SkinMetricTechName.texture_roughness,
        exports.SkinMetricTechName.redness,
        exports.SkinMetricTechName.surface_sebum,
        exports.SkinMetricTechName.telangiectasia,
    ],
    [exports.SkinMetricGroup.clarity_breakouts]: [
        exports.SkinMetricTechName.breakouts,
        exports.SkinMetricTechName.pores,
        exports.SkinMetricTechName.pie,
    ],
    [exports.SkinMetricGroup.tone_evenness]: [
        exports.SkinMetricTechName.pigmentation,
        exports.SkinMetricTechName.sun_spots,
        exports.SkinMetricTechName.melasma,
        exports.SkinMetricTechName.freckles,
    ],
    [exports.SkinMetricGroup.structure_aging]: [
        exports.SkinMetricTechName.lines,
        exports.SkinMetricTechName.fine_lines,
        exports.SkinMetricTechName.deep_lines,
        exports.SkinMetricTechName.nasolabial_wrinkles,
        exports.SkinMetricTechName.marionette_lines,
        exports.SkinMetricTechName.sagging,
        exports.SkinMetricTechName.jowls,
    ],
    [exports.SkinMetricGroup.eye_area]: [
        exports.SkinMetricTechName.dark_circles,
        exports.SkinMetricTechName.puffiness,
        exports.SkinMetricTechName.eye_bags,
        exports.SkinMetricTechName.lacrimal_grooves,
    ],
    [exports.SkinMetricGroup.baseline_properties]: [
        exports.SkinMetricTechName.skin_type,
        exports.SkinMetricTechName.ita,
        exports.SkinMetricTechName.skintone,
    ],
};
exports.SkinMetricAreaName = {
    face: 'face',
    nose: 'nose',
    forehead: 'forehead',
    left_eye: 'left_eye',
    right_eye: 'right_eye',
    left_cheek: 'left_cheek',
    right_cheek: 'right_cheek',
    perioral: 'perioral', // Used for bilateral fold assessments (nasolabial, marionette)
    upper_lip: 'upper_lip', // Granular upper lip region
    chin: 'chin', // Granular chin region
    jawline: 'jawline', // Jawline/mandibular border region
    t_zone: 't_zone',
    u_zone: 'u_zone',
};
exports.TreatmentAreaName = {
    ...exports.SkinMetricAreaName,
    neck: 'neck',
    jawline: 'jawline',
    lips: 'lips',
    chin: 'chin',
    body: 'body',
};
exports.TreatmentCategory = {
    medical_aesthetics: 'medical_aesthetics',
    facial_treatments: 'facial_treatments',
    skin_treatments: 'skin_treatments',
    body_treatments: 'body_treatments',
    wellness_specialised_treatments: 'wellness_specialised_treatments',
};
exports.TreatmentSlug = {
    anti_wrinkle: 'anti_wrinkle',
    dermal_fillers: 'dermal_fillers',
    skin_boosters: 'skin_boosters',
    bioremodelling: 'bioremodelling',
    pdo_threads: 'pdo_threads',
    collagen_stimulators: 'collagen_stimulators',
    fat_dissolving_injections: 'fat_dissolving_injections',
    facials: 'facials',
    acne_treatments: 'acne_treatments',
    hydrafacial: 'hydrafacial',
    chemical_peels: 'chemical_peels',
    microdermabrasion: 'microdermabrasion',
    led_light_therapy: 'led_light_therapy',
    microneedling: 'microneedling',
    plasma_pen: 'plasma_pen',
    oxygen_facials: 'oxygen_facials',
    exosomes: 'exosomes',
    rejuran: 'rejuran',
    laser_skin_resurfacing: 'laser_skin_resurfacing',
    ipl: 'ipl',
    nctf_skin_booster: 'nctf_skin_booster',
    prp_skin: 'prp_skin',
    fat_freezing: 'fat_freezing',
    ultrasonic_fat_cavitation: 'ultrasonic_fat_cavitation',
    rf_microneedling: 'rf_microneedling',
    hifu: 'hifu',
    muscle_defining: 'muscle_defining',
    iv_vitamin_infusions: 'iv_vitamin_infusions',
};
// ============================================================================
// CLASSIFICATION ENUMS FOR SKIN ANALYSIS
// ============================================================================
/**
 * Acne Severity (used for comedonal, inflammatory, cystic, and overall severity)
 */
exports.AcneSeverityLevel = {
    none: 'none',
    mild: 'mild',
    moderate: 'moderate',
    severe: 'severe',
};
exports.acneSeverityEnum = Object.values(exports.AcneSeverityLevel);
/**
 * Sensitivity Classifications
 */
exports.SensitivityClassification = {
    resilient: 'resilient',
    normal: 'normal',
    sensitive: 'sensitive',
    very_sensitive: 'very_sensitive',
    extremely_sensitive: 'extremely_sensitive',
};
exports.sensitivityLevelEnum = Object.values(exports.SensitivityClassification);
/**
 * Skin Type Classifications
 */
exports.SkinTypeClassification = {
    oily: 'oily',
    normal: 'normal',
    dry: 'dry',
    combination: 'combination',
};
exports.skinTypeEnum = Object.values(exports.SkinTypeClassification);
/**
 * Skin Type for Zones (T-zone and U-zone cannot be "combination")
 */
exports.skinTypeZoneEnum = ['oily', 'normal', 'dry'];
/**
 * ITA (Individual Typology Angle) Classifications
 */
exports.ITAClassification = {
    very_light: 'very_light',
    light: 'light',
    intermediate: 'intermediate',
    tan: 'tan',
    brown: 'brown',
    dark: 'dark',
};
exports.itaClassEnum = Object.values(exports.ITAClassification);
/**
 * Fitzpatrick Phototype
 */
exports.FitzpatrickType = {
    I: 'I',
    II: 'II',
    III: 'III',
    IV: 'IV',
    V: 'V',
    VI: 'VI',
};
exports.fitzpatrickEnum = Object.values(exports.FitzpatrickType);
/**
 * Skin AI Metric Group Names (Stage 2)
 */
exports.SkinAIMetricGroup = {
    SKIN_SENSITIVITY: 'skin_sensitivity',
    CLARITY_BREAKOUTS: 'clarity_breakouts',
    TONE_EVENNESS: 'tone_evenness',
    STRUCTURE_AGING: 'structure_aging',
    EYE_AREA: 'eye_area',
    BASELINE_PROPERTIES: 'baseline_properties',
};
exports.SKIN_AI_METRIC_GROUPS = Object.values(exports.SkinAIMetricGroup);
/**
 * Journal Tag Keys
 * These are the keys used to store journal tags in the database.
 * The frontend should use these keys and translate them for display.
 */
exports.JournalTagKey = {
    HEAVY_WORKOUT: 'heavy_workout',
    POOR_SLEEP: 'poor_sleep',
    DRANK_ALCOHOL: 'drank_alcohol',
    STRESSED: 'stressed',
    FEELING_SICK: 'feeling_sick',
    ATE_JUNK_FOOD: 'ate_junk_food',
    TRAVELED: 'traveled',
    WEATHER_CHANGE: 'weather_change',
    MENSTRUATING: 'menstruating',
};
exports.journalTagKeyEnum = [
    exports.JournalTagKey.HEAVY_WORKOUT,
    exports.JournalTagKey.POOR_SLEEP,
    exports.JournalTagKey.DRANK_ALCOHOL,
    exports.JournalTagKey.STRESSED,
    exports.JournalTagKey.FEELING_SICK,
    exports.JournalTagKey.ATE_JUNK_FOOD,
    exports.JournalTagKey.TRAVELED,
    exports.JournalTagKey.WEATHER_CHANGE,
    exports.JournalTagKey.MENSTRUATING,
];
exports.JOURNAL_TAG_KEYS = Object.values(exports.JournalTagKey);
/**
 * Change Event Attribution Type
 *
 * Attribution type for skin metric change events based on timing relative
 * to environment shifts. Uses biology-aware lookback windows based on each
 * metric's half-life parameters.
 *
 * - skin_change: True skin change, no recent environment shift in lookback window
 * - environment_adjustment: Change detected within active shift phase (0 → 3× fast half-life)
 *   where fast EMA is still converging to new environment
 * - settling: Change detected in settling phase (3× fast → 2× slow half-life)
 *   where slow EMA is being pulled toward converged fast EMA
 */
exports.ChangeEventAttribution = {
    SKIN_CHANGE: 'skin_change',
    ENVIRONMENT_ADJUSTMENT: 'environment_adjustment',
    SETTLING: 'settling',
};
//# sourceMappingURL=skin.js.map